import type { RouteRecordRaw } from "vue-router"

const Base = () => import("./components/Base.vue")
const Dashboard = () => import("./views/Dashboard.vue")
const Transactions = () => import("./views/Transactions.vue")
const Categories = () => import("./views/Categories.vue")
const SearchTerms = () => import("./views/SearchTerms.vue")
const Balances = () => import("./views/Balances.vue")
const Processing = () => import("./views/Processing.vue")
const YearTable = () => import("./views/YearTable.vue")
const Budget = () => import("./views/Budget.vue")
const Reports = () => import("./views/Reports.vue")
const Investments = () => import("./views/Investments.vue")
const InvestmentAccount = () => import("./views/InvestmentAccount.vue")
const ProcessingTimestamps = () => import("./views/ProcessingTimestamps.vue")
const AmortizeItems = () => import("./views/AmortizeItems.vue")
const CategoryGraph = () => import("./views/CategoryGraph.vue")

const routes: RouteRecordRaw[] = [
  {
    path: "/finances",
    component: Base,
    children: [
      { path: "", component: Dashboard, name: "finances:dashboard" },
      {
        path: "transactions/",
        component: Transactions,
        name: "finances:transactions",
      },
      {
        path: "categories/",
        component: Categories,
        name: "finances:categories",
      },
      {
        path: "search-terms/",
        component: SearchTerms,
        name: "finances:search-terms",
      },
      { path: "balances/", component: Balances, name: "finances:balances" },
      {
        path: "processing/",
        component: Processing,
        name: "finances:processing",
      },
      { path: "reports/", component: Reports, name: "finances:reports" },
      {
        path: "year-table/",
        component: YearTable,
        name: "finances:year-table",
      },
      { path: "budget/", component: Budget, name: "finances:budget" },
      {
        path: "investment/:id/",
        component: InvestmentAccount,
        name: "finances:investment-account",
      },
      {
        path: "investment/",
        component: Investments,
        name: "finances:investments",
      },
      {
        path: "processing-timestamps",
        component: ProcessingTimestamps,
        name: "finances:processing-timestamps",
      },
      {
        path: "amortize-items/",
        component: AmortizeItems,
        name: "finances:amortize-items",
      },
      {
        path: "category-graph/",
        component: CategoryGraph,
        name: "finances:category-graph",
      },
    ],
  },
]

export default routes
